/* TimedMessageBarComponent template */
import { Fragment, FunctionalComponent, h, Host } from '@stencil/core'; // eslint-disable-line @typescript-eslint/no-unused-vars
import { TimedMessageBarComponent } from './cwc-timed-message-bar';

/**
 * Definition of  parameters that the template needs to work.
 */
interface TimeMessageBarTemplateProps {
  /**
   * The class instance that provides controller functionality for the template
   */
  controller: TimedMessageBarComponent;
  // Specify parameters that are required to be passed down to the template here.
}

const TimedMessageBarTemplate: FunctionalComponent<TimeMessageBarTemplateProps> = ({ controller }) => {
  const getContent = () => {
    if (controller.url) {
      return (
        <a class="wrapper" href={controller.url}>
          {getInnerContent()}
        </a>
      );
    } else {
      return <div class="wrapper">{getInnerContent()}</div>;
    }
  };

  const getInnerContent = () => {
    return (
      <Fragment>
        <div class="label">
          <slot name="label" />
          {controller.image ? <img class="floating-image" src={controller.image} /> : ''}
        </div>
        <div class="text">
          <slot name="text-message" />
        </div>
        <div class="more-info">
          <slot name="more-info" />
        </div>
      </Fragment>
    );
  };

  return <Host>{getContent()}</Host>;
};

export default TimedMessageBarTemplate;
